import { c as _c } from "react/compiler-runtime";
import { FormSelect } from '@systemeio/ui';
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerCommunityEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface TriggerCampaignItemProps extends EditTriggerItemInterface<TriggerCommunityEditInterface> {}
const TriggerCommunityItem = t0 => {
  const $ = _c(16);
  const {
    triggers,
    trigger,
    idx,
    errors,
    setRules,
    onDelete,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== errors.automationTriggers || $[4] !== idx || $[5] !== isStatic || $[6] !== setRules || $[7] !== t || $[8] !== trigger.community || $[9] !== trigger.id || $[10] !== triggers) {
    t2 = t3 => {
      const {
        data,
        onOpen
      } = t3;
      return <><FormSelect disabled={isStatic} onOpen={() => onOpen(AutomationRuleTriggersDataEnum.enrolled_in_community)} label={t("dashboard.community.title")} required={true} placeholder={t("dashboard.automation_rule.choose_community")} value={trigger.community?.id} staticData={trigger.community && getDataFromObj(trigger.community)} data={data.communityData} onChange={data_0 => setRules(prev => ({
          ...prev,
          triggers: triggers.map((el, i) => {
            if (idx === i) {
              return {
                ...el,
                community: {
                  id: data_0
                }
              };
            } else {
              return el;
            }
          })
        }))} error={errors.automationTriggers[trigger.id]?.community?.join("")} /></>;
    };
    $[3] = errors.automationTriggers;
    $[4] = idx;
    $[5] = isStatic;
    $[6] = setRules;
    $[7] = t;
    $[8] = trigger.community;
    $[9] = trigger.id;
    $[10] = triggers;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== trigger) {
    t3 = <EditTriggerWrapper trigger={trigger} onDelete={t1}>{t2}</EditTriggerWrapper>;
    $[12] = t1;
    $[13] = t2;
    $[14] = trigger;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
export default TriggerCommunityItem;